import React from "react";

const SelectOptionFilter = ({
  label,
  id,
  name,
  value,
  onChange,
  options,
  className,
}) => {
  const classCustom = `${className ? className : ""} all-option-filter-box`;
  return (
    <div className={classCustom}>
      <label htmlFor={id}>{label} : </label>
      <select
        className="input"
        id={id}
        name={name}
        onChange={onChange}
        value={value}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectOptionFilter;
